module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XI",
      "title": "XI"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "4px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "4px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("AAE")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Arabian Archaeology and Epigraphy")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("AHPA")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Arabic History of the Patriarchs of Alexandria")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("BSOAS ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Bulletin of the School of Oriental and African Studies")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("CCDATJ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Christian Community Development Association"), _c('br'), _vm._v("\n                    Theological Journal")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("CSCO")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Corpus Scriptorum Christianorum Orientalium")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("DOP ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Dumbarton Oaks Papers")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JA")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal Asiatique")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JAOS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JCSSS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal of the Canadian Society for Syriac Studies")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JECS ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal of Early Christian Studies")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JRA")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal of Religion in Africa")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JSP")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal for the Study of the Pseudepigrapha")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JSS ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal of Semitic Studies")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("ME ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Medieval Encounters")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("NPNF")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A Select Library of the Nicene and Post-Nicene Fathers of the Church. Edited by Phillip Schaff et al. 14 vols. Buffalo, NY: Christian Literature, 1819–1893.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("OC")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Oriens Christianus")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("PG")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Patrologia cursus completus. Series Graeca. Edited by J. P. Migne. 166 vols. Paris: Migne, 1857–1886.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("PO")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Patrologia Orientalis. Edited by René Graffin et al. 41 vols. Paris, 1894–1984.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("ROC ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Revue de l’Orient Chrétien")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("STAC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Studien und Texte zu Antike und Christentum")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("StPatr ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Studia Patristica ")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "title": "XII"
    }
  })])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0